import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserAPIModelsERoles } from 'user-ts-ng-client';

import { AuthService } from '@core/auth/auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const allowedRoles = (route.data?.['allowedRoles'] ?? route.data?.['roles'] ?? []) as
    | UserAPIModelsERoles[]
    | undefined;
  const userRole = authService.getRole();

  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  if (userRole && allowedRoles.includes(userRole)) {
    return true;
  }

  void router.navigate(['/dashboard']);

  return false;
};
